import { Box } from '@chakra-ui/react';
import {Routes,Route} from 'react-router-dom';
import { memo } from 'react';
import {default as Publish} from './Publish';
import ReviewResults from './ReviewResults';



export const DefaultPublishResults = () =>{
  return <div>
    Publish Results
  </div>
}


const PublishResults = () => {
  return (
    <Routes>
      <Route path="/" element={<Publish  />}/>
      <Route path="publish" element={<Publish />} />
      <Route path="review-results/*" element={<ReviewResults />} />
    </Routes>
  )
}

export default memo(PublishResults);